import { TextField } from "@mui/material";
import { FieldProps } from "formik";
import { FC, useMemo, useState } from "react";

export interface StandardTextBoxProps {
    id: string,
    label: string,
    width?: number,
    isHidden?: boolean,
    maxLength?: number,
    readonly?: boolean
}

export const StandardTextBox: FC<StandardTextBoxProps & FieldProps> = ({ field, form: { touched, errors }, ...props }) => {

    const [isError, setIsError] = useState<boolean>(false);

    const determineError = useMemo(() => {

        if (errors[field.name] && touched[field.name]) {
            setIsError(true);
        }
        else {
            setIsError(false);
        }

    }
        , [touched, errors]);

    return (
        <>
            <TextField
                id={props.id}
                label={props.label}
                disabled={props.readonly}
                helperText={errors[field.name]?.toString()}
                error={isError}
                variant='outlined'
                type={props.isHidden ? 'password' : 'text'}
                style={{ width: props.width, marginRight: '10px' }}
                {...field}
                size='small'
                inputProps={{ maxLength: props.maxLength }}
                sx={{ "& .Mui-focused .MuiIconButton-root": { color: "primary.main" } }}
            />

        </>
    )

}
